module.exports = __webpack_public_path__ + "img/蓝莓4.09489121.png";